import { gql } from '@apollo/client';

export const QUERY = gql`
  query MemberSeasonParticipants($organizationId: ID!, $seasonParticipantId: Int!, $seasonParticipantType: String!) {
    memberSeasonParticipants(
      organizationId: $organizationId
      seasonParticipantId: $seasonParticipantId
      seasonParticipantType: $seasonParticipantType
    ) {
      id
      seasonParticipantId
      seasonParticipantType
      member {
        id
      }
    }
  }
`;
